<div class="auth-wrapper">
  <div class="align-items-center grid h-full">
    <div class="col-6 h-full">
      <div class="gc-auth-leftPanel">
        <div class="gc-idnty-container">
          <div class="gc-logo">
            <a href=""><img src="../../assets/images/io-logo-green.svg" alt="IOHealth"/></a>
          </div>
          <div class="">
            <p class="mt-5 ">{{logoText}}</p>
          </div>
        </div>
        <div class="gc-auth-slider">
          <img src="../../assets/images/banner.svg" alt="banner.svg" class="w-full"/>
        </div>
        <div class="gc-auth-icons-row">
          <img src="../../assets/images/product-icons/ioIQ.svg" alt="ioIQ" class="auth-icon-io-iq" />
          <img src="../../assets/images/product-icons/ioDoc.svg" alt="ioDoc" class="auth-icon-io-doc" />
          <img src="../../assets/images/product-icons/ioAssist.svg" alt="ioAssist" class="auth-icon-io-assist" />
          <img src="../../assets/images/intuition.png" alt="Intuition" class="auth-icon-intuition" />
        </div>
      </div>
    </div>
    <div
      class="col-6 relative justify-content-center flex align-items-center h-full"
    >
      <div class="gc-auth-form-container">
        <h1>Welcome</h1>
  <!--      <p>
          "Lorem ipsum dolor sit amet, consectetur dipiscing elit, sed do
          eiusmod tempor incididunt
        </p> -->
        <form #loginForm="ngForm" (ngSubmit)="loginWithCognito()">
          <div class="p-inputgroup mb-5">
            <input
              type="email"
              [(ngModel)]="user.email"
              name="email"
              placeholder="Email address"
              class="p-inputtext"
              required
            />
          </div>
          <div>
            <p-password
              [(ngModel)]="user.password"
              name="password"
              [feedback]="false"
              [toggleMask]="true"
              placeholder="Password"
              required
            >
            </p-password>
          </div>
          <div class="flex justify-content-between mt-3">
            <div class="">
              <a routerLink="/forgot-password">Forgot password?</a>
            </div>
          </div>
          <button type="submit" [disabled]="!loginForm.valid" class="login-btn">
            Log in
          </button>
        </form>
        <button (click)="loginWithMicrosoft()" class="sso-btn">
          <img src="../../assets/images/windows-22-logo.svg" alt="" width="22px"> <span>Login via SSO</span>
        </button>
      </div>

      <app-footer></app-footer>
    </div>
  </div>
</div>

<app-loader-wrapper [loading]="loading"></app-loader-wrapper>
